import { render } from "./AssignmentsContainer.vue?vue&type=template&id=20d6ad74"
import script from "./AssignmentsContainer.vue?vue&type=script&lang=js"
export * from "./AssignmentsContainer.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/musora-web-platform/musora-web-platform/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__